import classNames from "classnames";
import { LoadingDots } from "PFComponents/loading_dots";
import React from "react";

import css from "./wrapped_loading_dots.module.scss";

type WrappedLoadingDotsProps = React.ComponentProps<typeof LoadingDots>;

export const WrappedLoadingDots = ({ className, ...otherProps }: WrappedLoadingDotsProps): JSX.Element => (
  <LoadingDots {...otherProps} className={classNames(className, css.loadingDots)} />
);
